import { request } from "../utils/request";

const monitorApi = {
    // 获取试卷列表
    getexamList(data) {
        return request({
            method: "POST",
            url: "/api/Exammanage/examlist/getexamList",
            data
        });
    },
    //提前收卷 - 未交卷考生列表
    getExamStudentList(data) {
      return request({
        method: "POST",
        url: "/api/aheadSubmit/aheadSubmit/getStudent",
        data
      });
    },
    //提前收卷 - 提前收卷
    submitExamStudentList(data) {
      return request({
        method: "POST",
        url: "/api/aheadSubmit/aheadSubmit/aheadSubmit",
        data
      });
    },
    //添加考生 - 未参加考试的考生
    getNoExamStudent(data){
      return request({
        method: "POST",
        url: "/api/aheadSubmit/aheadSubmit/getNoExamStudent",
        data
      });
    },
    //添加考生 - 添加考生参加考试
    insertExamStudent(data){
      return request({
        method: "POST",
        url: "/api/aheadSubmit/aheadSubmit/insertExamStudent",
        data
      });
    },
    //补考考生列表接口
    makeUpExamUserList(data){
      return request({
        method: "POST",
        url: "/api/ksgl/examManager/makeUpExamUserList",
        data
      });
    },
    //补考补考接口
    makeUpExam(data){
      return request({
        method: "POST",
        url: "/api/ksgl/examManager/makeUpExam",
        data
      });
    },
}

export default monitorApi;
